<template>
  <com-page>
    <div class="flex items-center">
      <div class="h-400px flex flex-col justify-between">
        <el-card header="营收数据">
          <div class="flex items-center justify-around">
            <div class="item_wrapper center flex-col">
              <h2>￥{{ revenueData.totalAmount || 0 }}</h2>
              <div>营收总额(元)</div>
            </div>
            <div class="item_wrapper center flex-col">
              <h2>￥{{ revenueData.rechargeAmount || 0 }}</h2>
              <div>充值营收(元)</div>
            </div>
            <div class="item_wrapper center flex-col">
              <h2>￥{{ revenueData.monthCardAmount || 0 }}</h2>
              <div>月卡营收(元)</div>
            </div>
            <div class="item_wrapper center flex-col">
              <h2>￥{{ revenueData.userWithdrawAmount || 0 }}</h2>
              <div>用户提现(元)</div>
            </div>
            <div class="item_wrapper center flex-col">
              <h2>￥{{ revenueData.monthCardRefundAmount || 0 }}</h2>
              <div>月卡退款(元)</div>
            </div>
          </div>
        </el-card>
        <el-card header="其他交易数据" class="mt-15px">
          <div class="flex items-center justify-between">
            <div class="item_wrapper center flex-col">
              <h2>{{ otherData.giveAmount || 0 }}</h2>
              <div>赠送金(元)</div>
            </div>
            <div class="item_wrapper center flex-col">
              <h2>{{ otherData.giveWithdrawAmount || 0 }}</h2>
              <div>赠送金提现(元)</div>
            </div>
            <div class="item_wrapper center flex-col">
              <h2>{{ otherData.chargeAmount || 0 }}</h2>
              <div>充电订单金额(元)</div>
            </div>
            <div class="item_wrapper center flex-col">
              <h2>{{ otherData.chargeRefundAmount || 0 }}</h2>
              <div>退单金额(元)</div>
            </div>
          </div>
        </el-card>
      </div>
      <div class="flex flex-1 h-400px ml-15px" style="width: 100%">
        <el-card header="工作台" style="width: 100%; flex: 1">
          <div class="worker_wrapper h-300px">
            <div class="flex items-center justify-between mb-8px">
              <div class="flex items-center">
                <div class="label">离线设备</div>
                <div class="ml-20px">当前离线设备{{ workerData.offlineDeviceCount }}台</div>
              </div>
              <div class="w-60px h-40px flex items-center justify-end icon" @click="handleClick">
                <i class="el-icon-arrow-right" />
              </div>
            </div>
            <div v-for="(item, index) in workerData.dashboardLogs" :key="index" class="mb-8px">
              <div class="flex items-center justify-between">
                <div class="flex items-center">
                  <div class="label">
                    {{ item.type === 'DEMAND_REPORT' ? '需求反馈' : '用户反馈' }}
                  </div>
                  <div class="ml-20px">{{ item.content }}</div>
                </div>
                <div
                  class="w-60px h-40px flex items-center justify-end icon"
                  @click="handleOther(item)"
                >
                  <i class="el-icon-arrow-right" />
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <div>
      <el-card header="订单数据" class="mt-15px">
        <div class="flex items-center justify-around">
          <div class="item_wrapper center flex-col">
            <h2>{{ orderData.chargeOrderNumber || 0 }}</h2>
            <div>充电订单总数</div>
          </div>
          <div class="item_wrapper center flex-col">
            <h2>{{ orderData.rechargeOrderNumber }}</h2>
            <div>充值订单数</div>
          </div>
          <div class="item_wrapper center flex-col">
            <h2>{{ orderData.monthCardOrderNumber || 0 }}</h2>
            <div>月卡订单数</div>
          </div>
          <div class="item_wrapper center flex-col">
            <h2>{{ orderData.errorChargeOrderNumber || 0 }}</h2>
            <div>异常订单数</div>
          </div>
          <div class="item_wrapper center flex-col">
            <h2>{{ orderData.refundOrderNumber || 0 }}</h2>
            <div>退单订单数</div>
          </div>
          <div class="item_wrapper center flex-col">
            <h2>{{ orderData.userWithdrawNumber || 0 }}</h2>
            <div>用户提现订单数</div>
          </div>
          <div class="item_wrapper center flex-col">
            <h2>{{ orderData.monthCardRefundOrder || 0 }}</h2>
            <div>月卡退款订单数</div>
          </div>
        </div>
      </el-card>
    </div>
    <div class="flex items-center">
      <el-card header="网点数据" class="mt-15px" style="width: 50%">
        <div class="flex items-center justify-between">
          <div class="item_wrapper center flex-col">
            <h2>{{ storeData.storeNumber || 0 }}</h2>
            <div>网点数</div>
          </div>
          <div class="item_wrapper center flex-col">
            <h2>{{ storeData.deviceNumber || 0 }}</h2>
            <div>设备总数</div>
          </div>
          <div class="item_wrapper center flex-col">
            <h2>{{ storeData.offlineDeviceNumber || 0 }}</h2>
            <div>离线设备数</div>
          </div>
        </div>
      </el-card>
      <div class="flex flex-1 ml-16px" style="width: 100%">
        <el-card header="用户概况" class="mt-15px" style="width: 100%">
          <div class="flex items-center justify-around">
            <div class="item_wrapper center flex-col">
              <h2>{{ userData.partnerNumber || 0 }}</h2>
              <div>合伙人数</div>
            </div>
            <div class="item_wrapper center flex-col">
              <h2>{{ userData.businessNumber || 0 }}</h2>
              <div>商家数</div>
            </div>
            <div class="item_wrapper center flex-col">
              <h2>{{ userData.userNumber || 0 }}</h2>
              <div>普通用户数</div>
            </div>
            <div class="item_wrapper center flex-col">
              <h2>{{ userData.chargeUserNumber || 0 }}</h2>
              <div>充电用户数</div>
            </div>
            <div class="item_wrapper center flex-col">
              <h2>{{ userData.rechargeUserNumber || 0 }}</h2>
              <div>充值用户数</div>
            </div>
            <div class="item_wrapper center flex-col">
              <h2>{{ userData.monthCardUserNumber || 0 }}</h2>
              <div>月卡用户数</div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </com-page>
</template>

<script>
import { queryHomeDashboard, dashboardLog, read } from '@/api/statistics'

export default {
  data() {
    return {
      orderData: {}, // 订单数据
      revenueData: {}, // 营收数据
      storeData: {}, // 网点数据
      userData: {}, // 用户数据
      otherData: {}, // 其他数据
      time: null,
      workerData: {
        offlineDeviceCount: 0,
        dashboardLogs: []
      }
    }
  },
  methods: {
    init() {
      this.getData()
      this.getWorker()
    },
    async getData() {
      try {
        const {
          data: { orderData, revenueData, storeData, userData, otherData }
        } = await queryHomeDashboard()
        this.orderData = orderData
        this.revenueData = revenueData
        this.storeData = storeData
        this.userData = userData
        this.otherData = otherData
        console.log('数据面板 :>> ', orderData, revenueData, storeData, userData)
        if (this.time) clearInterval(this.time)
        this.time = setInterval(() => {
          this.getData()
        }, 60000)
      } catch (err) {
        console.log('err :>> ', err)
      }
    },
    async getWorker() {
      const query = {
        pageIndex: 1,
        pageSize: 1000
      }
      try {
        const {
          data: { offlineDeviceCount, dashboardLogs }
        } = await dashboardLog(query)
        this.workerData.offlineDeviceCount = offlineDeviceCount
        this.workerData.dashboardLogs = dashboardLogs
        console.log('工作台 :>> ', this.workerData)
      } catch (err) {
        console.log('err22333 :>> ', err)
      }
    },
    handleClick() {
      this.$router.push('/equipment/error-list')
    },
    handleOther(row) {
      this.handleRead(row)
      if (row.type === 'DEMAND_REPORT') {
        this.$router.push('/feedback/need-feedback')
        return
      }
      this.$router.push('/feedback/user-feedback')
    },
    async handleRead(row) {
      try {
        const params = {
          code: row.code
        }
        const res = await read(params)
        console.log('res :>> ', res)
      } catch (err) {
        console.log('err :>> ', err)
      }
    }
  },
  mounted() {
    // this.init()
  },
  deactivated() {
    clearInterval(this.time)
  },
  activated() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.item_wrapper {
  padding: 15px;
  h2 {
    margin-bottom: 5px;
  }
  div {
    white-space: nowrap;
  }
}

.worker_wrapper {
  overflow-y: auto;
  .label {
    padding: 10px;
    border: solid 1px #409eff;
    white-space: nowrap;
  }
  .icon {
    cursor: pointer;
  }
}
</style>
